// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'capitalize',
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        body: {
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        root: {
          padding: theme.spacing(1.5, 2),
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.selected,
            },
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius * 2,
          boxShadow: theme.customShadows?.card || theme.shadows[1],
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
  };
}
